/**
 * QueryProvider — TanStack Query dùng chung. Server-state tách bạch client-state (patterns.md).
 * Mặc định stale-while-revalidate: dữ liệu cũ hiển thị ngay, revalidate nền.
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";

const DEFAULT_STALE_MS = 30_000;
const DEFAULT_RETRY = 2;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: DEFAULT_STALE_MS,
        retry: DEFAULT_RETRY,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export interface QueryProviderProps {
  readonly client: QueryClient;
  readonly children: ReactNode;
}

export function QueryProvider({ client, children }: QueryProviderProps) {
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
